import { ChangeDetectorRef, Component, Inject, Input } from '@angular/core';

import { ListenersRegistry } from '@skylab-shared/utils';

import { EventBus, EventBusBase } from '@skylab-angular-shared/core';

import { NgClass } from '@angular/common';
import { Dictionary } from '@skylab-shared/types';
import { BehaviorSubject } from 'rxjs';
import { UIEvents } from '../../utils/ui-events';
import { ValidationIconComponent } from '../validation-icon/validation-icon.component';

@Component({
    selector: 'skl-validation-area',
    templateUrl: './validation-area.component.html',
    imports: [ValidationIconComponent, NgClass]
})
export class ValidationAreaComponent extends ListenersRegistry(class {}) {
    // bindings
    @Input() public areaId!: string;

    // other
    private validations: { errors: Dictionary<string[]>, warnings: Dictionary<string[]>, info: Dictionary<string[]> };
    public errorMessages: string[];
    public warningMessages: string[];
    public infoMessages: string[];
    public allWarnings: string[];

    public areaViolation$ = new BehaviorSubject<any>(null);

    public constructor(
        @Inject(EventBus) private eventBus: EventBusBase,
        private readonly changeDetector: ChangeDetectorRef
    ) {
        super();
        this.validations = {
            errors: {},
            warnings: {},
            info: {}
        };
        this.errorMessages = [];
        this.warningMessages = [];
        this.infoMessages = [];
        this.allWarnings = []; // info and warnigns
    }

    private validationChangeEventId!: string;
    private areaValidationChangeObserverId!: string;

    public ngAfterViewInit(): void {
        this.areaValidationChangeObserverId = this.eventBus.observe(UIEvents.ControlValidationUpdated, (data: any) => {
            if (data.areaId === this.areaId) {
                this.onValidationsChanged(data);
            }
        });
    }

    public ngOnDestroy(): void {
        this.deregisterAllListeners();
        this.eventBus.deleteObserver([this.areaValidationChangeObserverId, this.validationChangeEventId]);
    }

    public onValidationsChanged(params: { key: string; errors: string[]; warnings: string[]; info: string[]}): void {
        if (params.errors != null) {
            this.validations.errors[params.key] = params.errors;
        }
        if (params.warnings != null) {
            this.validations.warnings[params.key] = params.warnings;
        }
        if (params.info != null) {
            this.validations.info[params.key] = params.info;
        }
        this.assignValidationsToCollections();
    }

    public assignValidationsToCollections(): void {
        this.errorMessages = this.parseValidationsToMessages(this.validations.errors);
        this.warningMessages = this.parseValidationsToMessages(this.validations.warnings);
        this.infoMessages = this.parseValidationsToMessages(this.validations.info);
        this.allWarnings = [...this.warningMessages, ...this.infoMessages];
        this.areaViolation$.next({
            isError: this.errorMessages.length > 0,
            isWarning: this.allWarnings.length > 0
        });
        this.changeDetector.detectChanges();
    }

    private parseValidationsToMessages(validations: Dictionary<string[]>): string[] {
        const messages = [];
        for (const key in validations) {
            messages.push(...validations[key]);
        }
        return messages;
    }
}
